import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useServiceStatus({
  category,
  enabled = true,
}: {
  enabled?: boolean;
  category: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['service-status', category], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `service-status/${category}`,
      });
      return res;
    },
    enabled,
  });
}
